/**
 * api.js — re-export barrel
 *
 * Split into focused modules:
 *   _client.js   – shared axios instance, auth helpers, circuit breaker
 *   roomApi.js   – room CRUD and directory endpoints
 *   assetsApi.js – model/asset presigned-URL endpoints
 *
 * All existing `import { roomApi } from './api'` etc. continue to work.
 */
import api from './_client';

export { roomApi } from './roomApi';
export { assetsApi } from './assetsApi';
export { avatarApi } from './avatarApi';

// Generic API functions
export const genericApi = {
  // Health check
  healthCheck: async () => {
    try {
      const response = await api.get('/health');
      return response.data;
    } catch (error) {
      if (error.code === 'ERR_NETWORK' || error.code === 'ECONNREFUSED') {
        console.warn('API health check: Connection unavailable');
      } else {
        console.error('Health check failed:', error.message);
      }
      return { status: 'error', message: 'API unavailable' };
    }
  }
};

// Error handling utilities
export const handleApiError = (error, fallbackMessage = 'An error occurred') => {
  if (error.response) {
    return {
      message: error.response.data?.message || fallbackMessage,
      status: error.response.status,
      details: error.response.data
    };
  } else if (error.request) {
    return {
      message: 'Network error - please check your connection',
      status: 0,
      details: null
    };
  } else {
    return {
      message: error.message || fallbackMessage,
      status: -1,
      details: null
    };
  }
};

export default api;
